// Shared heading styles for modal content components
const headingStyles = {
  h3: {
    fontWeight: 900,
    fontSize: '2rem',
    letterSpacing: '-0.5px',
    color: '#111',
    marginTop: 0,
    marginBottom: 12,
  },
  h4: {
    fontWeight: 800,
    fontSize: '1.2rem',
    color: '#222',
    letterSpacing: '-0.2px',
    marginTop: 24,
    marginBottom: 8,
  },
};

export default headingStyles;
